import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslation from "./en/translation.json";
import translation from "./zh/translation.json";

i18next.use(initReactI18next).init({
  lng: localStorage.getItem("language") || "zh",
  debug: false,
  resources: {
    en: {
      translation: enTranslation,
    },
    zh: {
      translation: translation,
    },
  },
});

i18next.on("languageChanged", (lng) => {
  globalThis.document.title = i18next.t("PubLink 支付平台");
});
